import { render } from "./SelectAttribute.vue?vue&type=template&id=1c024f0a&scoped=true"
import script from "./SelectAttribute.vue?vue&type=script&lang=js"
export * from "./SelectAttribute.vue?vue&type=script&lang=js"

import "./SelectAttribute.vue?vue&type=style&index=0&id=1c024f0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c024f0a"]])

export default __exports__